import { render } from "./LeaveApply.vue?vue&type=template&id=10456ebc"
import script from "./LeaveApply.vue?vue&type=script&lang=js"
export * from "./LeaveApply.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/gmX3YL_q/0/internal/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__